import { __assign } from 'tslib';
import * as React from 'react';

var SvgMinus = function SvgMinus(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120"
  }, props), React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h120v120H0z"
  }), React.createElement("path", {
    d: "M4808.012-3630.794a4.957 4.957 0 0 0 1.352-3.514v-9.865a4.744 4.744 0 0 0-1.487-3.649 4.954 4.954 0 0 0-3.513-1.351h-41.083l-21.353.135a4.784 4.784 0 0 0-3.513 1.351 4.682 4.682 0 0 0-1.419 3.581l.067 9.8a4.372 4.372 0 0 0 1.419 3.581 4 4 0 0 0 3.514 1.352l62.5.067a4.9 4.9 0 0 0 3.516-1.488Z",
    style: {
      opacity: 0.3
    },
    transform: "translate(-4712.402 3706.923)"
  }), React.createElement("path", {
    d: "M4808.012-3634.984a4.953 4.953 0 0 0 1.352-3.513v-9.866a4.743 4.743 0 0 0-1.487-3.648 4.959 4.959 0 0 0-3.513-1.352h-41.083l-21.353.135a4.785 4.785 0 0 0-3.513 1.352 4.682 4.682 0 0 0-1.419 3.581l.067 9.8a4.374 4.374 0 0 0 1.419 3.581 4 4 0 0 0 3.514 1.351l62.5.068a4.906 4.906 0 0 0 3.516-1.489Z",
    style: {
      fill: "#afafaf"
    },
    transform: "translate(-4712.402 3706.923)"
  }), React.createElement("path", {
    d: "M4808.012-3641.354a4.957 4.957 0 0 0 1.352-3.514v-9.865a4.744 4.744 0 0 0-1.487-3.649 4.953 4.953 0 0 0-3.513-1.351l-62.436.135a4.784 4.784 0 0 0-3.513 1.351 4.684 4.684 0 0 0-1.419 3.582l.067 9.8a4.376 4.376 0 0 0 1.419 3.582 4 4 0 0 0 3.514 1.351l62.5.068a4.907 4.907 0 0 0 3.516-1.49Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-4712.402 3706.923)"
  }));
};

export { SvgMinus as default };